module.exports = "/dist/984ae3788bccf682cc5eaaf9398a41ef.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-400italic.woff2
// module id = 155
// module chunks = 0